import {
  orderBy,
} from 'lodash'

const filterBankTransfers = async ({
  // bankTransfersAmountFilter,
  bankTransfersAmountFilter: {
    maxAmount = '',
    minAmount = '',
    value = '',
  } = {},
  bankTransfers = [],
  bankTransfersDateFilter = null, // ?
  filterStatus = "all", // "all", "Matched", "Unmatched", "Unreconciled", "Delta0"
  transactionSearchTerm = "",
} = {}) => {
  const filteredBankTransfers = bankTransfers.filter(({
    bankTransferAmountFormattedString = '',
    calendarDateStr = '',
    isBankTransferMatched = false,
    isBankTransferReconciled = false,
    label = '',
    invoice0DeltaAmount = null,
  } = {}) => {
    const isMatchingStatus = (
      filterStatus.toLowerCase() === "all"
    ) || (
      filterStatus.toLowerCase() === "matched" && isBankTransferMatched
    ) || (
      filterStatus.toLowerCase() === "unmatched" && !isBankTransferMatched
    ) || (
      filterStatus.toLowerCase() === "unreconciled" && !isBankTransferReconciled
    ) || (
      filterStatus.toLowerCase() === "delta0" && invoice0DeltaAmount !== null && invoice0DeltaAmount !== undefined && invoice0DeltaAmount === 0
    ) || (
      filterStatus.toLowerCase() === "reconciled" && isBankTransferReconciled
    )

    const matchesSearch = label
      .toLowerCase()
      .includes(transactionSearchTerm.toLowerCase())

    const transactionDate = new Date(
      calendarDateStr.split("/").reverse().join("-"),
    )
    const withinTransactionDateRange = bankTransfersDateFilter
      ? transactionDate >= bankTransfersDateFilter.start
          && transactionDate <= bankTransfersDateFilter.end
      : true

    const transactionCost = parseFloat(
      bankTransferAmountFormattedString,
    )

    const matchesTransactionAmount = value
      ? bankTransferAmountFormattedString.includes(value)
      : true

    const matchesTransactionAmountRange = (!minAmount || transactionCost >= +minAmount)
  && (!maxAmount || transactionCost <= +maxAmount)

    return (
      isMatchingStatus
        && matchesSearch
        && withinTransactionDateRange
        && matchesTransactionAmount
        && matchesTransactionAmountRange
    )
  })

  const sortedBankTransfers = orderBy(
    filteredBankTransfers,
    ['dateTimestamp', 'label'],
    ['desc', 'asc'],
  )
  // console.log(sortedBankTransfers[0])
  // console.log(sortedBankTransfers[1])

  return ({
    sortedBankTransfers,
    // filteredBankTransfers,
  })
}

export default filterBankTransfers
